import { render, staticRenderFns } from "./ChallengeStatistics.vue?vue&type=template&id=6077a9db&"
import script from "./ChallengeStatistics.vue?vue&type=script&lang=ts&"
export * from "./ChallengeStatistics.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports